export default [
    {
        path: '/selectImg',
        component: () => import('views/modules/selectImg/index'),
        meta: {
            title: '选择图片',
            noAI: true,
        },
    },
    {
        path: '/selectVideo',
        component: () => import('views/modules/selectVideo/index'),
        meta: {
            title: '选择视频',
        },
    },
    {
        path: '/selectFile',
        component: () => import('views/modules/selectFile/index'),
        meta: {
            title: '选择文件',
        },
    },
    {
        path: '/selectLink',
        component: () => import('views/modules/selectlink/index'),
        meta: {
            title: '选择链接',
        },
    },
];
